import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, testId }) => (
  <div className="mb-12 sm:mb-16">
    <Reveal>
      <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.35em] text-sky-500/90 mb-4">
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 data-testid={testId} className="font-display font-bold uppercase tracking-tight text-3xl sm:text-5xl text-gray-50 leading-none">
        {title}
      </h2>
    </Reveal>
  </div>
);
